export function getHostname() {
    const host = window.location.host; // includes port if present
    const hostName = window.location.hostname; // excludes port
    const result = hostName ? hostName : host.split(':')[0];
    return result.replace(/\./g, '');
}